import { render } from "./NewGroup.vue?vue&type=template&id=32aeabfd&scoped=true"
import script from "./NewGroup.vue?vue&type=script&lang=js"
export * from "./NewGroup.vue?vue&type=script&lang=js"

import "./NewGroup.vue?vue&type=style&index=0&id=32aeabfd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32aeabfd"]])

export default __exports__